import { redeemables } from '@repo/data';

interface Redeemable {
  id: number;
  name: string;
  brand: string;
  set: string;
  set_type: string;
  ipfs_hash_png: string;
}

export const getRedeemable = async (
  redeemableId: number,
): Promise<Redeemable | null> => {
  const item = redeemables.find((item: Redeemable) => item.id === redeemableId);

  return item || null;
};
